import React, { useMemo, useState } from "react";

import ApiError from "shared/components/feedback/modals/ErrorModal";
import GenericModal from "shared/components/feedback/modals/common/GenericModal";
import PropTypes from "prop-types";
import ReactDOM from "react-dom";

const AppErrorContext = React.createContext();

export const AppErrorProvider = (props) => {
    const [error, setError] = useState(null);

    const removeError = () => {
        setError(null);
        ReactDOM.render(null, document.getElementById("divAppErrorModal"));
    };

    const addError = (e) => {
        setError(e);
        const modalContent = <ApiError error={e} popup />;
        const modal = (
            <GenericModal content={modalContent} parent="divAppErrorModal" />
        );
        ReactDOM.render(modal, document.getElementById("divAppErrorModal"));
    };

    const redirect = (e) => {
        setError(e);
        const modalContent = <ApiError error={e} />;
        const modal = (
            <GenericModal content={modalContent} parent="divAppErrorModal" />
        );
        ReactDOM.render(modal, document.getElementById("divAppErrorModal"));
        globalThis.location.assign(e.errorPageURL);
    };

    const contextValue = useMemo(() => {
        return {
            error,
            removeError,
            addError,
            redirect,
        };
    }, [error]);

    return (
        <AppErrorContext.Provider value={contextValue}>
            {props.children}
        </AppErrorContext.Provider>
    );
};

AppErrorProvider.propTypes = {
    children: PropTypes.node,
};

export default AppErrorContext;
